import React from 'react';
import "./Extra.css";
import {HiLocationMarker} from 'react-icons/hi';
import CountUp from 'react-countup';
import {animate, motion} from 'framer-motion';

function Extra() {
  return (
    <div>
      <div className="extra-wrapper">
        <div className="padding innerWidth flexCenter extra-container">
            <div className="flexColStart extra-left">
                <div className="blueCircle"></div>
                <div className="extra-title">
                    <motion.h1 initial={{y:"4rem", opacity:0}} animate={{y:0, opacity:1}} transition={{duration:4, type:"ease-in"}}>Discover <br/> The Most Suitable <br/> Property</motion.h1>
                </div>

                <div className="flexColStart extra-des">
                    <span className='secondaryText'>Find Beautiful Properties That Suite You The Best</span>
                    <span className='secondaryText'>You will not face any difficulties in finding the best residence for you</span>
                </div>

                <div className="flexCenter search-bar">
                    <HiLocationMarker color="blue" size={25}></HiLocationMarker>
                    <input type="text" />
                    <button className="button">Search</button>
                </div>

                <div className="flexCenter stats">
                    <div className="flexColCenter stat">
                        <span>
                            <CountUp start={0} end={9000} duration={4} />
                        <span> + </span>
                        </span>
                        <span className='secondaryText'>Premium Properties</span>
                    </div>
                    <div className="flexColCenter stat">
                        <span>
                            <CountUp start={0} end={1000} duration={4} />
                        <span> + </span>
                        </span>
                        <span className='secondaryText'>Happy Customers</span>
                    </div>
                    <div className="flexColCenter stat">
                        <span>
                            <CountUp start={0} end={25} duration={4} />
                        <span> + </span>
                        </span>
                        <span className='secondaryText'>Awards Won</span>
                    </div>
                </div>
            </div>

            <div className="flexCenter extra-right">
                <div className="image-container">
                    <motion.img initial={{x:"4rem", opacity:0}} animate={{x:0, opacity:1}} transition={{duration:4, type:"ease-in"}} src="buildings.jpeg" alt="main image" />
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Extra
